export const infiniteListPageSize = 60;
export const infiniteListDetailsViewPageSize = 10;
//UserParameterCodes
export const userParameterCodeShowDocumentPreview = "ShowDocumentPreview";